import {List, Typography} from '@mui/material';
import {ChangeEvent, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import socket, {IResponse} from '@sockets';
import SearchInput from '../search/SearchInput';
import IChannel from './IChannel';
import ChannelItem from './ChannelItem';
import MyChannelList from './MyChannelList';
import {Link} from 'react-router-dom';

const loadingChannel: IChannel[] = [
	{
		id: 1,
		name: '',
		lastMessage: '',
		lastTime: new Date(),
		image: '',
		isSeen: false,
		isMember: false
	},
	{
		id: 2,
		name: '',
		lastMessage: '',
		lastTime: new Date(),
		image: '',
		isSeen: false,
		isMember: false
	},
	{
		id: 3,
		name: '',
		lastMessage: '',
		lastTime: new Date(),
		image: '',
		isSeen: false,
		isMember: false
	},
	{
		id: 4,
		name: '',
		lastMessage: '',
		lastTime: new Date(),
		image: '',
		isSeen: false,
		isMember: false
	},
	{
		id: 5,
		name: '',
		lastMessage: '',
		lastTime: new Date(),
		image: '',
		isSeen: false,
		isMember: false
	}
];

export default function Network() {
	const [search, setSearch] = useState('');
	const [myChannels, setMyChannels] = useState<IChannel[]>(loadingChannel);
	const [topChannels, setTopChannels] = useState<IChannel[]>(loadingChannel);
	const [searchChannel, setSearchChannel] = useState<IChannel[]>(loadingChannel);
	const [searching, setSearching] = useState(false);
	const {t} = useTranslation();
	
	const handleChangeSearchFiled = (event: ChangeEvent<HTMLInputElement>) => {
		setSearch(event.target.value);
	};
	
	useEffect(() => {
		socket.emit('network:top_channels', null, (data: IResponse<IChannel[]>) => {
			if (data.success) {
				setTopChannels(data.result);
			}
		});
		socket.emit('network:my_channels', null, (data: IResponse<IChannel[]>) => {
			if (data.success) {
				setMyChannels(data.result.map(channel => {
					return {
						...channel,
						lastTime: new Date(channel.lastTime)
					};
				}));
			}
		});
	}, []);
	
	useEffect(() => {
		if (!search) {
			setSearchChannel(loadingChannel);
		}
		const delaySearch = setTimeout(() => {
			setSearchChannel(loadingChannel);
			if (search) {
				setSearching(true);
				socket.emit('network:search_channel', search, (data: IResponse<IChannel[]>) => {
					setSearching(false);
					if (data.success) {
						setSearchChannel(data.result);
					}
				});
			}
		}, 1000);
		
		return () => clearTimeout(delaySearch);
	}, [search]);
	
	const handleJoinChannel = (channel: IChannel) => {
		setTopChannels(topChannels.filter(c => c.id !== channel.id));
		setMyChannels([channel, ...myChannels]);
	};
	
	return (
		<div className="felx flex-col space-y-2 mx-5">
			<SearchInput placeholder={t('search_channel_placeholder')} value={search} onChange={handleChangeSearchFiled}/>
			{
				searching || searchChannel !== loadingChannel ?
					<List>
						{
							searchChannel.map(channel => <ChannelItem key={channel.id} channel={channel} onJoin={handleJoinChannel}/>)
						}
					</List>
					:
					<>
						<MyChannelList myChannels={myChannels}/>
						<div className="w-full flex flex-row justify-between pt-4">
							<Typography sx={{
								color: (theme) => theme.palette.mode === 'light' ? 'primary.900' : 'secondary50',
								fontSize: (theme) => theme.typography.fontSize
							}}
							            className="font-medium">{t('top_channels')}</Typography>
							<Link to={'/channels'}>
								<Typography
									sx={{
										color: (theme) => theme.palette.mode === 'light' ? 'primary.900' : 'secondary50',
										fontSize: (theme) => theme.typography.fontSize
									}}
									className="font-medium">{t('all_channels')}</Typography>
							</Link>
						</div>
						<List className="py-0">
							{
								topChannels.map(channel => <ChannelItem key={channel.id} channel={channel} onJoin={handleJoinChannel}/>)
							}
						</List>
					</>
			}
		</div>
	);
}
